import '@quasar/extras/material-icons/material-icons.css'
import QDate from 'quasar/src/components/date/QDate.js';import QIcon from 'quasar/src/components/icon/QIcon.js';import QSelect from 'quasar/src/components/select/QSelect.js';import QToggle from 'quasar/src/components/toggle/QToggle.js';import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';import Quasar from 'quasar/src/vue-plugin.js';
import lang from 'quasar/lang/ja.js'
import Vue from 'vue'
import './styles/quasar.scss'

Vue.use(Quasar, {
  config: {},
  components: {
    QDate,
    QIcon,
    QToggle,
    QTooltip,
    QSelect,
  },
  plugins: {
  },
  lang: lang,
})
